"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RowRule = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _index = require("../api/index");
var _Rule = require("../classes/Rule");
var _RowEval = require("../controllers/RowEval");
var RowRule = /*#__PURE__*/function () {
  function RowRule(evaluator, rule) {
    (0, _classCallCheck2["default"])(this, RowRule);
    if (!evaluator) throw new Error('Row can\'t be and empty field');
    this.evaluator = evaluator;
    this.rule = rule;
  }
  (0, _createClass2["default"])(RowRule, [{
    key: "getRow",
    value: function getRow() {
      return this.evaluator.row;
    }
  }, {
    key: "setRule",
    value: function setRule(rule) {
      this.rule = rule;
    }
  }, {
    key: "updateRule",
    value: function () {
      var _updateRule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this = this;
        var prj,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              prj = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                var row = _this.evaluator.row;
                var rule = _this.rule;
                var placerMcIndex = _this.evaluator.placerIndex;
                if (placerMcIndex > -1) {
                  row.placer[placerMcIndex].setRule(rule);
                  _this.evaluator.eval(true).then(function (res) {
                    rule.setVariantData(res.rule);
                    row.placer[placerMcIndex].setRule(rule);
                    resolve(null);
                  })["catch"](reject);
                } else {
                  row.setRule(rule);
                  if (row.clPlacerChilds.length > 0 || row.father != null) {
                    if (!prj) throw new Error('Project parameter is mandatory if try update rule on placer');
                    _RowEval.RowEval.evalRowPlacer(row, prj).then(resolve)["catch"](reject);
                  } else {
                    _this.evaluator.eval(true).then(function (res) {
                      rule.setVariantData(res.rule);
                      row.setRule(rule);
                      resolve(res);
                    })["catch"](reject);
                  }
                }
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function updateRule() {
        return _updateRule.apply(this, arguments);
      }
      return updateRule;
    }()
  }, {
    key: "overrideRule",
    value: function overrideRule() {
      this.evaluator.row.rule = this.rule;
      this.evaluator.row.reg = this.rule.reg;
    }
  }], [{
    key: "loadRule",
    value: function () {
      var _loadRule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(row) {
        var _this2 = this;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (row.rule && row.reg === row.rule.reg) {
                  if (!(row.rule instanceof _Rule.Rule)) row.rule = new _Rule.Rule(row.rule);
                  resolve(row.rule);
                } else {
                  _this2._getRule(row).then(function (newRule) {
                    if (row.setRule) row.setRule(newRule);else {
                      console.warn("Implements windows and walls rule");
                      row.rule = newRule;
                      row.reg = newRule.reg;
                    }
                    resolve(newRule);
                  })["catch"](reject);
                }
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function loadRule(_x) {
        return _loadRule.apply(this, arguments);
      }
      return loadRule;
    }()
  }, {
    key: "updateRule",
    value: function () {
      var _updateRule2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(row, rule) {
        var placerMcIndex,
          prj,
          _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              placerMcIndex = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : -1;
              prj = _args3.length > 3 ? _args3[3] : undefined;
              return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (placerMcIndex > -1) {
                  row.placer[placerMcIndex].setRule(rule);
                  _RowEval.RowEval.evalRow(row, placerMcIndex, true).then(function (res) {
                    rule.setVariantData(res.rule);
                    row.placer[placerMcIndex].setRule(rule);
                    resolve(null);
                  })["catch"](reject);
                } else {
                  row.setRule(rule);
                  if (row.clPlacerChilds.length > 0 || row.father != null) {
                    if (!prj) throw new Error('Project parameter is mandatory if try update rule on placer');
                    _RowEval.RowEval.evalRowPlacer(row, prj).then(function (res) {
                      resolve(res);
                    })["catch"](reject);
                  } else {
                    _RowEval.RowEval.evalRow(row, -1, true).then(function (res) {
                      rule.setVariantData(res.rule);
                      row.setRule(rule);
                      resolve(res);
                    })["catch"](reject);
                  }
                }
              }));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function updateRule(_x2, _x3) {
        return _updateRule2.apply(this, arguments);
      }
      return updateRule;
    }()
  }, {
    key: "setVariant",
    value: function () {
      var _setVariant2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(variantValObj, rule, catalog) {
        var data, variantStr, values, i;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = {
                model: rule.model || "",
                neutro: rule.neutro || "",
                item: rule.item || "",
                cModel: rule.cModel || "",
                reg: rule.reg || ""
              };
              if ((0, _isArray["default"])(variantValObj)) {
                values = [];
                for (i = 0; i < variantValObj.length; i++) {
                  values.push(variantValObj[i].cod + "=" + variantValObj[i].value);
                }
                variantStr = values.join(',');
              } else {
                variantStr = variantValObj ? variantValObj.cod + "=" + variantValObj.value : "";
              }
              return _context4.abrupt("return", new _promise["default"](function (resolve, reject) {
                RowRule._setVariant(variantStr, catalog, data).then(function (res) {
                  rule.setVariantData(res);
                  resolve(res);
                })["catch"](reject);
              }));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function setVariant(_x4, _x5, _x6) {
        return _setVariant2.apply(this, arguments);
      }
      return setVariant;
    }()
  }, {
    key: "setBlobVariant",
    value: function setBlobVariant(_ref, rule, catalog) {
      var cod = _ref.cod,
        base64 = _ref.base64,
        mime = _ref.mime;
      var data = {
        model: rule.model || "",
        neutro: rule.neutro || "",
        item: rule.item || "",
        cModel: rule.cModel || "",
        reg: rule.reg || ""
      };
      var blobData = {
        codVariant: cod,
        variantData: base64,
        mimeType: mime
      };
      return new _promise["default"](function (resolve, reject) {
        _index.CrulesAPI.ruleSetParamBlob(catalog, data, blobData, function (res) {
          rule.setVariantData(res);
          resolve(res);
        }, reject);
      });
    }
  }, {
    key: "_setVariant",
    value: function () {
      var _setVariant3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(variantChanges, catalog, ruleData) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", new _promise["default"](function (resolve, reject) {
                _index.CrulesAPI.ruleSetParam(catalog, variantChanges, ruleData, resolve, reject);
              }));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function _setVariant(_x7, _x8, _x9) {
        return _setVariant3.apply(this, arguments);
      }
      return _setVariant;
    }()
  }, {
    key: "_getRule",
    value: function _getRule(row) {
      return new _promise["default"](function (resolve, reject) {
        _index.CrulesAPI.loadRule(row.catalog, row.reg, '', row.cmodel || '', row.cod || '', row.model || '', row.neutro || '', function (rule) {
          resolve(new _Rule.Rule(rule));
        }, function (err) {
          console.error(err);
          reject(err);
        });
      });
    }
  }]);
  return RowRule;
}();
exports.RowRule = RowRule;
//# sourceMappingURL=RowRule.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/RowRule.js
// module id = 1256
// module chunks = 142